import { cn } from "@/lib/utils";

type BadgeVariant =
  | "default"
  | "brouillon"
  | "a_publier"
  | "publie"
  | "loue_vendu"
  | "archive"
  | "success"
  | "warning"
  | "accent"
  | "danger"
  | "info"
  | "vente"
  | "location"
  | "demande_envoyee"
  | "demande_acceptee"
  | "demande_refusee"
  | "date_fixee"
  | "intervention_faite"
  | "reporting_recu"
  | "en_retard";

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: "bg-gray-200 text-text-secondary",
  brouillon: "bg-gray-200 text-text-secondary",
  a_publier: "bg-warning-light text-warning",
  publie: "bg-accent-light text-accent",
  loue_vendu: "bg-success-light text-success",
  archive: "bg-gray-200 text-text-muted",
  success: "bg-success-light text-success",
  warning: "bg-warning-light text-warning",
  accent: "bg-accent-light text-accent",
  danger: "bg-danger-light text-danger",
  info: "bg-[#EEF2FF] text-[#6366F1]",
  vente: "bg-warning-light text-warning",
  location: "bg-accent-light text-accent",
  demande_envoyee: "bg-warning-light text-warning",
  demande_acceptee: "bg-accent-light text-accent",
  demande_refusee: "bg-danger-light text-danger",
  date_fixee: "bg-[#EEF2FF] text-[#6366F1]",
  intervention_faite: "bg-success-light text-success",
  reporting_recu: "bg-success-light text-success",
  en_retard: "bg-danger-light text-danger",
};

export function Badge({
  variant = "default",
  children,
  className,
}: BadgeProps) {
  return (
    <span
      className={cn(
        "rounded px-2 py-0.5 text-xs font-medium tracking-wide inline-flex items-center",
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
